import React, { useState } from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import axios from "axios";

const TicketSearch = ({ onSearchResult, ticketList }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!searchQuery.trim()) {
      onSearchResult(null);
      return;
    }

    setIsSearching(true);

    // Simulate search delay
    setTimeout(() => {
      if (!Array.isArray(ticketList)) {
        onSearchResult(null);
        setIsSearching(false);
        return;
      }

      const query = searchQuery.trim().toLowerCase();
      const results = ticketList.filter(ticket => {
        // Search by ticket ID (with or without prefix)
        const ticketIdStr = String(ticket.ticket_id || "");
        const ticketIdWithPrefix = `#ILETK00${ticket.ticket_id}`;
        
        // Search by description
        const description = String(ticket.ticket_desc || "").toLowerCase();
        
        // Search by member name
        const memberName = String(ticket.member_name || "").toLowerCase();
        
        // Search by ticket type
        const ticketType = String(ticket.ticket_type || "").toLowerCase();
        
        return (
          ticketIdStr.includes(query) ||
          ticketIdWithPrefix.toLowerCase().includes(query) ||
          description.includes(query) ||
          memberName.includes(query) ||
          ticketType.includes(query)
        );
      });

      onSearchResult(results.length > 0 ? results : null);
      setIsSearching(false);
    }, 300);
  };

  return (
    <form onSubmit={handleSearch} className="w-full max-w-md">
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search by Ticket ID"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            height: "36px",
            borderRadius: "18px",
            "& fieldset": {
              borderRadius: "18px",
            },
            "&:hover fieldset": {
              borderColor: "rgba(0, 0, 0, 0.23)",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1976d2",
            },
          },
          "& .MuiInputBase-input": {
            padding: "8px 14px",
          },
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  type="submit"
                  disabled={isSearching}
                  edge="end"
                  size="small"
                  sx={{
                    color: searchQuery.trim() ? "inherit" : "transparent",
                  }}
                >
                  <ArrowForward fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </form>
  );
};

export default TicketSearch;
